import { render, staticRenderFns } from "./viewStockholder.vue?vue&type=template&id=14d38885&scoped=true&"
import script from "./viewStockholder.vue?vue&type=script&lang=js&"
export * from "./viewStockholder.vue?vue&type=script&lang=js&"
import style0 from "./viewStockholder.vue?vue&type=style&index=0&id=14d38885&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d38885",
  null
  
)

export default component.exports